import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Inject,
  NgZone,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  ViewEncapsulation,
  DOCUMENT
} from '@angular/core';
// import { WINDOW } from './shared/utilities/window';
// import { URLRedirectConstants } from './shared/constants/URL-redirects.constants';
import { NavigationEnd, Router } from '@angular/router';
// import { WINDOW } from './shared/utilities/window';
// import { URLRedirectConstants } from './shared/constants/URL-redirects.constants';
import { Meta } from '@angular/platform-browser';
import { environment } from '@env/environment';
import { CanonicalService } from './core/services/canonical.service';
import { initialLoadScriptTags, scriptTags } from './js-script.constants';
import { filter, takeUntil } from 'rxjs/operators';
import { GoogleMapsLoaderService } from './core/services/google-maps-loader.service';
import { RoomvoService } from './core/services/roomvo.service';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { WINDOW } from './shared/utilities/window';

@Component({
    selector: 'mflooring-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy,AfterViewInit {
	isBrowser: boolean;
	private destroy$ = new Subject<void>();
	private hasLoadedScripts = false;

	@HostListener('window:scroll')
	@HostListener('window:click')
	@HostListener('window:mousemove')
	@HostListener('window:touchstart')
	@HostListener('window:keydown')
	handleUserInteraction() {
	  if (this.hasLoadedScripts || !this.isBrowser) return;
	  this.hasLoadedScripts = true;
	  this.roomvoService.loadRoomvoScript();
	  if (environment.production) {
		this.injectScript();
		this.loadGoogleMaps();
		this.addMetaTag();
	  }
	}

	constructor(
		private router: Router,
		@Inject(DOCUMENT) private documentRef: Document,
		@Inject(WINDOW) private windowRef: Window,
		@Inject(PLATFORM_ID) private platformId: string,
		private meta: Meta,
		public canonical: CanonicalService,
		private renderer: Renderer2,
		private readonly ngZone: NgZone,
		private googleMapsLoader: GoogleMapsLoaderService,
		private roomvoService: RoomvoService


	) {
		this.isBrowser = isPlatformBrowser(this.platformId);

		this.router.events
		.pipe(
			filter(event => event instanceof NavigationEnd),
			takeUntil(this.destroy$)
		)
		.subscribe(() => {
			this.documentRef.body.classList.remove('custom-modal-open');
		});

		
	}
	ngAfterViewInit(): void {
		this.injectInitialScript();
	}

	ngOnInit() {

		// const url = this.route;
		// const currentPath = this.windowRef.location.pathname;
		// let redirectPath = URLRedirectConstants[currentPath];
		// if (redirectPath) {
		// 	redirectPath = decodeURIComponent(redirectPath);
		// 	this.router.navigateByUrl(redirectPath);
		// }

		this.canonical.updateCanonicalUrl();
		if (environment.appendNofllow) {
			this.addNofollowNoindex();
		}
		if (this.isBrowser) {
			this.windowRef.addEventListener('click', function (event: any) {
				if (event?.target?.classList.contains('save-preference-btn-handler')) {
					window.location.reload(); // refresh the page
				}
			});
			if (this.windowRef.self === this.windowRef.top) {
				// // Load otSDKStub.js
				// const sdkScript = this.renderer.createElement('script');
				// sdkScript.type = 'text/javascript';
				// sdkScript.charset = 'UTF-8';
				// sdkScript.src =
				// 	'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
				// sdkScript.setAttribute(
				// 	'data-domain-script',
				// 	environment.oneTrustKey
				// );
				// this.renderer.appendChild(this.documentRef.head, sdkScript);

				// // Load OtAutoBlock.js
				// const autoBlockScript = this.renderer.createElement('script');
				// autoBlockScript.type = 'text/javascript';
				// autoBlockScript.src =
				// 	`https://cdn.cookielaw.org/consent/${environment.oneTrustKey}/OtAutoBlock.js`;
				// this.renderer.appendChild(this.documentRef.body, autoBlockScript);

				// // Optional log
				// sdkScript.onload = () => this.injectInitialScript();
				// autoBlockScript.onload = () => console.log('OneTrust AutoBlock loaded');
			}
		}
	
		
		// setTimeout(() => {
		// 	// addMetaTag is a function that adds a meta tag to the head of the document
		// 	this.addMetaTag();
		// 	// injectScript is a function that injects a script into the head of the document
		// 	this.injectScript();
		// }, 4000);

		// this.router.events.pipe(
		// 	filter((event: RouterEvent): event is NavigationStart => event instanceof NavigationStart)
		// ).subscribe((event: NavigationStart) => {
		// 	const redirectPath = URLRedirectConstants[event.url];
		// 	if (redirectPath) {
		// 		this.router.navigateByUrl(decodeURIComponent(redirectPath), { replaceUrl: true });
		// 	}
		// });
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
		// if (this.chatbotScript) {
		// 	this.renderer.removeChild(this.documentRef.body, this.chatbotScript);
		// }
	}
	
	addNofollowNoindex() {
		this.meta.addTags([{ name: 'robots', content: 'noindex' }]);
	}


	private metaTagAdded:boolean = false;
	addMetaTag() {
		if (!this.metaTagAdded){
			const metaTag: HTMLMetaElement = this.documentRef.createElement('meta');
			metaTag.setAttribute('name', 'google-site-verification');
			metaTag.content = 'y_eokX9R5UU54ZYGW_zB-6rLIEYqgJlFtXievbE0cQA';
			this.documentRef.head.appendChild(metaTag);
			this.metaTagAdded=true
		}
	}
	

	private scriptLoaded:boolean = false;
	injectScript() {
		const timeoutId = setTimeout(() => {
			if (!this.scriptLoaded){
				this.ngZone.runOutsideAngular(() => {
					for (let key in scriptTags) {
						// check if the script tag has a url
						if (
							scriptTags[key].url !== undefined &&
							scriptTags[key].renderOnlyForProd
						) {
							// create a new script tag
							const script = this.renderer.createElement('script');
							this.renderer.setAttribute(script, 'src', scriptTags[key].url);
							// set script async attribute
							script.async = true;
							// check if the script tag has a name
							if (scriptTags[key].name === 'hs-script') {
								// set the script tag's id to 'hs-script-loader'
								this.renderer.setAttribute(script, 'id', 'hs-script-loader');
							}
							if (scriptTags[key].name === 'hsforms') {
								script.charset = 'UTF-8';
								script.type = 'text/javascript';
							}
							// append the script tag to the head of the document
							if (scriptTags[key].location === 'head') {
								this.renderer.appendChild(this.documentRef.head, script);
							} else if (scriptTags[key].location === 'body') {
								script.type = 'text/javascript';
								this.renderer.setAttribute(script, 'type', 'text/javascript');
								this.renderer.appendChild(this.documentRef.body, script);
							}
						}
					}
					this.scriptLoaded = true;
			
				})
			}
		}, 1000);

		this.destroy$.subscribe(() => {
			clearTimeout(timeoutId);
		});
	}
	injectInitialScript() {


				this.ngZone.runOutsideAngular(() => {
					for (let key in initialLoadScriptTags) {
						// check if the script tag has a url
						if (initialLoadScriptTags[key].url !== undefined && initialLoadScriptTags[key].renderOnlyForProd) {
							// create a new script tag
							const script = this.renderer.createElement('script');
							this.renderer.setAttribute(script, 'src', initialLoadScriptTags[key].url);
							// set script async attribute
							script.async = true;
							
						
							// append the script tag to the head of the document
							if (initialLoadScriptTags[key].location === 'head') {
								this.renderer.appendChild(this.documentRef.head, script);
							} else if (initialLoadScriptTags[key].location === 'body') {
								script.type = 'text/javascript';
								this.renderer.setAttribute(script, 'type', 'text/javascript');
								this.renderer.appendChild(this.documentRef.body, script);
							}
						}
					}
			
				})

	}


	private googleMapsLoaded:boolean = false;

	loadGoogleMaps(){
		if (!this.googleMapsLoaded){
			this.googleMapsLoader
			.load()
			.then(() => {
				this.googleMapsLoaded=true
			  console.log('Google Maps API loaded!');
			})
			.catch((err) => {
			  console.error('Google Maps failed to load:', err);
			});
		}
	
	}



	//   private chatbotScript?: HTMLScriptElement;
	//   loadChatbot(): void {
	// 	const script = this.renderer.createElement('script');
	// 	script.src = 'assets/scripts/chatbot-loader.js';
	// 	script.type = 'text/javascript';
	// 	this.renderer.appendChild(this.documentRef.head, script);
	// 	this.chatbotScript = script;
	//   }
}
